export default "__VITE_ASSET__BayweMCR__"